import { render, staticRenderFns } from "./Wire.vue?vue&type=template&id=797bf539&scoped=true&"
import script from "./Wire.vue?vue&type=script&lang=js&"
export * from "./Wire.vue?vue&type=script&lang=js&"
import style0 from "./Wire.vue?vue&type=style&index=0&id=797bf539&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797bf539",
  null
  
)

export default component.exports